import { actionClient } from '@/api'
import lodash from 'lodash'

const state = {
  collection: [],
  pagination: {},
  total: 0,
  products: { // product list view model
    list: [], // 商品列表
    pagination: null, // 分页
    requested: false, // 是否已请求
    requesting: false, // 当前是否在请求中
    loadMore: false // 当前是否加载更多
  }
}

// actions
const actions = {
  async collection({ commit, dispatch, state }, query) {
    console.log(query)
    const data = await actionClient.get('member/activity/products', { query })
    commit('setProducts', data)
    return state
  },
  async loadProducts({ commit, state }, { loadMore = false, ...props}) {
    if (state.products.requesting) {
      return
    }

    if (loadMore) {
      const { haxNextPage } = state.products.pagination
      if (!haxNextPage) {
        return
      }
    }
    const pagination = { limit: 6, currentPage: loadMore && state.products.pagination ? state.products.pagination.currentPage + 1 : 1}
    commit('setProducts', { ...state.products, requesting: true, loadMore })
    console.log(props, pagination)
    const { collection, meta } = await actionClient.get('member/activity/products', { query: {...props, pagination } })
    commit('setProducts', {
      requested: true,
      requesting: false,
      loadMore,
      list: collection,
      pagination: meta.pagination
    })
  },
}


// mutations
const mutations = {
  // setProducts(state, data) {
  //   state.collection = data.collection,
  //   state.pagination = data.meta.pagination,
  //   state.total = data.meta.total
  // },
  setProducts(state, products) {
    if (products.loadMore) {
      products.list = lodash.uniqBy([...state.products.list, ...products.list], p => p.id)
    }
    state.products = products
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
